import React from "react";
import PropTypes from "prop-types";

export const ConsoleMdi = ({height = "20", width = "20"} = {}) => (
  <span
    className="mdi mdi-console"
    height={height}
    width={width}
  ></span>
);

ConsoleMdi.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
